/* template */
<template><div class="coupon-packages-list-wrap"><div class="check-detail-list" v-if="(mallData.list.length)"><div class="coupon-packages-title">{{$t('goodsDetail.includes')}}</div><coupon-package v-for="(item, index) in (mallData.list)" :key="item.index" :item="(item)" :currency="(mallData.currency)" :product-type="(mallData.productType)" class="coupon-package-item"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m14f180f0"}'>
@import "../../../lib/stylus/variable.styl"
.coupon-packages-list-wrap
  margin-top -56rpx
  position relative
  background: #FCFDFE;
  box-shadow: 0 -10rpx 30rpx 0 rgba(228,228,228,0.03);
  border-radius: 30rpx 30rpx 0rpx 0rpx;
  .check-detail-wrap
    display flex
    justify-content center
    .check-detail-btn
      width 670rpx
      height 91rpx
      border: 1rpx solid #CDCDCD;
      display flex
      justify-content center
      align-items center
      border-radius: 26rpx;
      margin-top 52rpx
      font-size: 30rpx;
      color: #6D6D6D;
  .check-detail-list
    padding 39rpx 39rpx 0
    .coupon-packages-title
      font-weight: $fw-semi-bold;
      font-size: 30rpx;
      color: #333333;
      line-height: 28rpx;
      margin-bottom 27rpx
    .coupon-package-item
      margin-bottom 20rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { EnumCouponType } from '../../../lib/webx/defines'
import { ComponentsMixin } from '../../../lib/webx/mpx/mixins/page_detail/component'
createComponent({
  mixins: [ ComponentsMixin ],
  computed: {
    // 通乘券
    packageIsFixedPrice() {
      return Array.isArray(this.mallData.list) && this.mallData.list.reduce((prev, _package) => prev && _package.discount_type === EnumCouponType.FixedPrice, true)
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index14f180f0",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-package':getComponent(require("./coupon-package.mpx?component=true&componentId=coupon-package0bbcbfd7")),'fixed-coupon-package':getComponent(require("./fixed-coupon-package.mpx?component=true&componentId=fixed-coupon-package04913210"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
